var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81826 1.16699C4.5966 1.16699 1.98492 3.77866 1.98492 7.00033C1.98492 10.222 4.5966 12.8337 7.81826 12.8337C11.0399 12.8337 13.6516 10.222 13.6516 7.00033C13.6516 3.77866 11.0399 1.16699 7.81826 1.16699ZM10.525 4.80221C10.7725 5.00846 10.806 5.37629 10.5997 5.62378L7.68306 9.12378C7.58122 9.24598 7.43391 9.32129 7.27522 9.33228C7.11653 9.34327 6.96024 9.28897 6.84254 9.18197L5.09254 7.59106C4.85415 7.37435 4.83658 7.00542 5.0533 6.76704C5.27001 6.52866 5.63894 6.51109 5.87732 6.7278L7.17668 7.90904L9.70347 4.8769C9.90971 4.6294 10.2775 4.59597 10.525 4.80221Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmed);
export default __webpack_public_path__ + "static/media/confirmed.2c61aedeb7686065d852dc5e63206a5e.svg";
export { ForwardRef as ReactComponent };